import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  textStyle: {
    fontSize: 100,
    textAlign: 'center',
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  responsiveTextStyle: {
    overflow: 'hidden',
    textOverflow: 'clip',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    display: 'inline-block',
  },
});
